import { gql } from '@apollo/client';

export default gql`
  query getTicketUpgradeInformation($currentTicketClass: String!, $newTicketClass: String!, $carrierCode: String) {
    getTicketUpgradeInformation(currentTicketClass: $currentTicketClass, newTicketClass: $newTicketClass, carrierCode: $carrierCode) {
      carrierCode
      ticketType
      points
      bucketCodes
    }
  }
`;
